import { render } from "./datatableComponnent.vue?vue&type=template&id=45023833&scoped=true"
import script from "./datatableComponnent.vue?vue&type=script&lang=js"
export * from "./datatableComponnent.vue?vue&type=script&lang=js"

import "./datatableComponnent.vue?vue&type=style&index=0&id=45023833&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45023833"]])

export default __exports__